import React, { MouseEventHandler } from 'react';
import { getBrand } from 'flow/brands/brands';
import useAppContext from 'flow/hooks/useAppContext';
import BaseModal from '../../ui-components/BaseModal';

interface Props {
    open: boolean;
    handleClose: () => void;
    onLinkClick?: MouseEventHandler<HTMLAnchorElement>;
}

const SignInHelperDialogEtisalat = ({
    open,
    handleClose,
    onLinkClick,
}: Props) => {
    const { i18next } = useAppContext();
    const activateAccountUrl = getBrand().passwordActionUrl
        ? `${getBrand().passwordActionUrl}/signin.jsp?token&activate`
        : null;

    return (
        <BaseModal
            open={open}
            ariaLabel={i18next.t('signin.helper.help')}
            onClose={handleClose}
            disableActions={true}
            disablePadding={true}
            onSubmit={null}
        >
            <div className="flex flex-col gap-3 p-4">
                <div>
                    <h2 className="font-bold">
                        {i18next.t('signin.username')}
                    </h2>
                    <p>{i18next.t('signin.help.info_username.atg')}</p>
                </div>

                <div>
                    <h2 className="font-bold">
                        {i18next.t('signin.password')}
                    </h2>
                    <p>
                        {i18next.t('signin.help.info_password.atg')}{' '}
                        <a
                            href={activateAccountUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={onLinkClick}
                            className="text-link"
                        >
                            {i18next.t('signin.help.activate_account')}
                        </a>
                    </p>
                </div>
            </div>
        </BaseModal>
    );
};

export default SignInHelperDialogEtisalat;
